<template>
  <div
    class="effect-setting setting-popup"
    v-if='boxData.judgeBox'
    :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex}"
    @mousedown.stop.prevent
  >
    <div
      class="setting-popup__drag-area"
      @mousedown="moveStart($event, true)"
      @mousemove="moveArea($event)"
      @mouseup="saveMoveState($event)" :style="{'cursor': 'move'}"
    >
      动画设置
    </div>

    <div class="settting-popup__content">
      <transition
        name="content-slide"
        @before-enter="onContentBeforeEnter"
        @after-enter="onContentAfterEnter"
      >
        <ul v-show="contentType === 'main'">
          <li class="box" :class="[key]" v-for="(box, key) in boxes" :key="key">
            <div class="box__head" @click="toggleBox(box, key)">
              <div
                class="icon"
                v-if="box.backBtn"
                @click.stop="boxTwoToggleChildMode();$analysis('animation_setting_panel,click_ee_effect_back,动画设置_出入场动画_返回');"
              >
                <icon url="../../../../static/svg/popups/arrow-left.svg"></icon>
              </div>
              <span>{{box.title}}</span>
              <icon :classNames="box.open ? ['fold', 'open'] : ['fold']" url="../../../../static/svg/left-arrow.svg" :width="18" :height="10"></icon>
            </div>
            <div class="box__body" :style="getBoxBodyStyle(key)">
              <template v-if="key === 'box-one'">
                <box-one
                  :sprite="sprite" ref="box"
                  @onItemClicked="showSide"
                ></box-one>
              </template>
              <template v-if="key === 'box-two'">
                <box-two
                  :sprite="sprite"
                  ref="box"
                  @childModeUpdated="boxTwoAddBackBtn"
                ></box-two>
              </template>
            </div>
          </li>
        </ul>
      </transition>

      <transition-group
        name="side-slide"
        @before-enter="onSideBeforeEnter"
        @after-enter="onContentAfterEnter"
      >
        <div
          class="side"
          v-for="(item, i) in sides"
          :key="i+'_transition-group'"
          v-show="contentType === item.name"
        >
          <div class="side__header">
            <i
              class="icon"
              @click="
                onSideToMain();
                contentType = 'main';
                $analysis(reports2[item.name]);
              "
              style="cursor: pointer; display: none"
            >
              <icon url="../../../../static/svg/popups/arrow-left.svg"></icon>
            </i>
            <span>{{item.title}}</span>
          </div>
          <div class="side__body">
            <path-effect-setting :sprite="sprite" v-if="item.name === 'pathAnim'"></path-effect-setting>
            <whirl-setting :sprite="sprite" v-if="item.name === 'whirl'"></whirl-setting>
            <shake-setting :sprite="sprite" v-if="item.name === 'shake'"></shake-setting>
          </div>
        </div>
      </transition-group>
    </div>

    <div class="setting-popup__close" @click="close"><i class="icon-popup-close"></i></div>
    <div class="setting-popup__mask" v-show="isShowMask"></div>
  </div>
</template>

<script>
import popup from '../../mixins/popup.vue'
import boxOne from './boxOne'
import boxTwo from './boxTwo'
import pathEffectSetting from '../../popups/pathEffectSetting.vue'
import whirlSetting from '../../popups/stayAnim/whirlSetting.vue'
import shakeSetting from '../../popups/stayAnim/shakeSetting.vue'
import icon from '../../common/icon.vue'

export default {
  name: 'effectSetting',
  mixins: [popup],
  components: {
    boxOne,
    boxTwo,
    pathEffectSetting,
    whirlSetting,
    shakeSetting,
    icon
  },
  data () {
    return {
      popupType: 'effectSetting',
      boxes: {
        'box-one': {
          open: true,
          title: '停留特效'
        },
        'box-two': {
          open: true,
          title: '出入场动画',
          backBtn: false
        }
      },
      contentType: 'main', // main, pathAnim, whirl, shake
      sides: [
        {name: 'pathAnim', title: '路径动画', popupHeight: 304},
        {name: 'whirl', title: '旋转动画', popupHeight: 425},
        {name: 'shake', title: '抖动动画', popupHeight: 550.8},
      ],
      reports: {
        none: 'animation_setting_panel,click_empty_stayEffect,动画设置_停留动画_无动画',
        pathAnim: 'animation_setting_panel,click_stayEffect_pathAnim,动画设置_停留动画_路径动画',
        whirl: 'animation_setting_panel,click_stayEffect_whirl,动画设置_停留动画_旋转动画',
        shake: 'animation_setting_panel,click_stayEffect_shake,动画设置_停留动画_抖动动画',
      },
      reports2: {
        pathAnim: 'animation_setting_panel,click_route_ani_back,动画设置_路径动画_返回',
        whirl: 'animation_setting_panel,click_rotate_ani_back,动画设置_旋转动画_返回',
        shake: 'animation_setting_panel,click_shake_ani_back,动画设置_抖动动画_返回',
      }
    }
  },
  computed: {
    boxBodyStyle () {

    }
  },
  watch: {
    'boxData.judgeBox': {
      handler (val) {
        if (val) {
          this.contentType = this.boxData.data.contentType || 'main';
          this.$nextTick(() => {
            this.boxTwoAddBackBtn(this.$refs.box[1].childMode);
            (this.$refs.box || []).map(v => v.render());
            this.$bus.emit(`effectSetting.${this.contentType || 'none'}`, {
              state: 'in'
            });
          });
        } else {
          this.onSideToMain();
        }
      }
    },
    contentType: {
      handler (val) {
        if (val === 'main') {
          (this.$refs.box || []).map(v => v.render());
        } else {
          this.$bus.emit(`effectSetting.${this.contentType || 'none'}`, {
            state: 'in'
          });
        }
      }
    }
  },
  created () {
    this.$bus.on('cancleStayAnim', () => {
      this.contentType = 'main';
    });

    this.$bus.on('undoRedoHandle', ({type, mod} = {}) => {
      this.renderBoxes();
    });
  },
  methods: {
    getBoxBodyStyle (key) {
      let box = this.boxes[key];
      let s = {
        height: 0
      };
      return box.open ? {} : s;
    },
    toggleBox (box, key) {
      box.open = !box.open;
    },

    renderBoxes () {
      (this.$refs.box || []).map(v => v.render());
    },

    showSide (boxOneItem) {
      this.$analysis(this.reports[boxOneItem.type]);
      if (boxOneItem.type === 'none') {
        this.sprite.updateEffect({pathAnim: null, stayAnim: {type: 'None'}}, true)
          .then(() =>{
            this.sprite.changeStyle();
            this.$bus.emit('updateEffect_vue', {
              sprite: this.sprite,
              effect: this.sprite.effect || {},
              type: 'path'
            });
          });
        this.renderBoxes();
        return;
      }

      this.contentType = boxOneItem.type;
    },

    boxTwoAddBackBtn (flag) {
      this.boxes['box-two'] = {
        ...this.boxes['box-two'],
        backBtn: flag
      }
    },

    boxTwoToggleChildMode () {
      this.$refs.box[1].toggleChildMode(false);
    },

    onContentBeforeEnter (el) {
      $(this.$el).css({
        height: 588
      })
    },
    onContentAfterEnter () {
      this.$el.style.removeProperty('height');
    },
    onSideBeforeEnter (el) {
      let item = (this.sides.filter(v => v.name === this.contentType) || [])[0];
      if (!item) {
        return;
      }
      $(this.$el).css({
        height: item.popupHeight || 588
      })
    },

    onSideToMain () {
      this.$bus.emit(`effectSetting.${this.contentType}`, {
        state: 'out'
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 258px;
  min-height: 180px;
  z-index: 35;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  box-shadow: 0 0 3px 1px #d8dee9;
  color: #474261;

  &__drag-area {
    line-height: 28px;
    background: #d8dee9;
    text-align: left;
    text-indent: 14px;
    cursor: move;
  }

  &__close {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 14px;
    line-height: 14px;
    width: 14px;
    cursor: pointer;
  }

  &__content {
    position: relative;
    padding: 14px 0;
    transition-duration: 0.5s;
    & ul, & li {
      transition-duration: 0.5s;
    }
  }

  &__mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(#ffffff, 0.7);
  }
}

.box {
  &.box-one {
    // height: 230px;
    margin-top: 1px;
    .box__body {
      height: 230px - 34px;
    }
  }
  &.box-two {
    // height: 310px;
    margin-top: 1px;
    .box__body {
      height: 310px - 34px + 20px;
    }
  }

  &__head {
    position: relative;
    display: flex;
    align-items: center;
    height: 34px;
    padding-left: 12px;
    padding-right: 12px;
    background-color: #f0f0f8;
    text-align: left;
    line-height: 34px;
  }

  &__body {
    overflow: hidden;
    transition-duration: .3s;
  }
}

.side {
  &__header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 34px;
    padding-left: 15px;
    background-color: #f0f0f8;
  }
}

.content-slide-enter-active, .content-slide-leave-active,
.side-slide-enter-active, .side-slide-leave-active {
  transition-duration: 0.3s;
  position: absolute;
}
.content-slide-enter, .content-slide-leave-to {
  transform: translateX(-100%);
}
.side-slide-enter, .side-slide-leave-to {
  transform: translateX(100%);
}

.icon {
  margin-right: 16px;
  line-height: 1;
  cursor: pointer;
}

.fold {
  position: absolute;
  right: 1em;
  top: 1em;
  transition-duration: 0.3s;
  transform: rotate(-90deg);
  &.open {
    transform: rotate(90deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popupsNew/effectSetting/effectSettingIndex.vue